module.exports = __webpack_public_path__ + "img/4m.194d88bc.jpg";